// extracted by mini-css-extract-plugin
export default {"container":"note_container__S7675","content":"note_content__uBpfo","textArea":"note_textArea__XhAoM","expanded":"note_expanded__0pUAS","footer":"note_footer__+-foD"};